import hotToast from "react-hot-toast";

const DURATION_MS = 3000;

function toContent(text) {
  if (text == null) return "";
  return typeof text === "string" ? text : String(text);
}

const baseOpts = { duration: DURATION_MS };

/**
 * Global toast — pass message text. Optional second arg: type.
 * @param {string} text
 * @param {"success"|"error"|"warning"|"info"|"loading"} [type="success"]
 * @returns {string} toast id (for dismissToast)
 */
export function toast(text, type = "success") {
  const content = toContent(text);
  switch (type) {
    case "error":
      return hotToast.error(content, baseOpts);
    case "warning":
      return hotToast(content, {
        ...baseOpts,
        className: "sendo-toast sendo-toast--warning",
        icon: "⚠️",
      });
    case "info":
      return hotToast(content, {
        ...baseOpts,
        className: "sendo-toast sendo-toast--info",
        icon: "ℹ️",
      });
    case "loading":
      return hotToast.loading(content, { duration: Infinity });
    case "success":
    default:
      return hotToast.success(content, baseOpts);
  }
}

export const toastSuccess = (text) => hotToast.success(toContent(text), baseOpts);
export const toastError = (text) => hotToast.error(toContent(text), baseOpts);
export const toastWarning = (text) => toast(text, "warning");
export const toastInfo = (text) => toast(text, "info");

/** Dismiss by id returned from toast() / toast.loading(). */
export const dismissToast = (id) => hotToast.dismiss(id);

export default toast;
